import Popover from "@components/ui/popover";
import { cn } from "@lib/cn";
import {
  IconDotsVertical,
  IconInfoCircle,
  IconTrash,
} from "@tabler/icons-react";
import { useState } from "react";

interface VersionsRowActionsProps {
  onVersionDetails: () => void;
  onDeleteSessions: () => void;
}

export const VersionsRowActions = ({
  onVersionDetails,
  onDeleteSessions,
}: VersionsRowActionsProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleAction = (action?: () => void) => {
    action?.();
    setIsOpen(false);
  };

  return (
    <Popover open={isOpen} onOpenChange={setIsOpen} placement="bottom-end">
      <Popover.Trigger
        className={cn(
          "tw-size-8 tw-flex tw-items-center tw-justify-center tw-cursor-pointer tw-rounded-lg hover:tw-bg-blue-50 tw-transition-colors",
          isOpen && "tw-bg-blue-50",
        )}
      >
        <IconDotsVertical className="tw-size-4 tw-text-blue" />
      </Popover.Trigger>
      <Popover.Content className="tw-w-48 tw-rounded-lg tw-border tw-border-solid tw-border-blue-100 tw-bg-white tw-shadow-md">
        <div className="tw-px-1 tw-py-1">
          <button
            type="button"
            onClick={() => handleAction(onVersionDetails)}
            className="tw-flex tw-h-9 tw-w-full tw-cursor-pointer tw-items-center tw-gap-1.5 tw-rounded tw-px-2 tw-font-sans tw-text-sm tw-text-blue tw-outline-none tw-transition-colors hover:tw-bg-blue-50"
          >
            <IconInfoCircle className="tw-size-4 tw-text-blue" />
            <span>Version details</span>
          </button>
          <button
            type="button"
            onClick={() => handleAction(onDeleteSessions)}
            className="tw-flex tw-h-9 tw-w-full tw-cursor-pointer tw-items-center tw-gap-1.5 tw-rounded tw-px-2 tw-font-sans tw-text-sm tw-text-blue tw-outline-none tw-transition-colors hover:tw-bg-blue-50"
          >
            <IconTrash className="tw-size-4 tw-text-blue" />
            <span>Delete all sessions</span>
          </button>
        </div>
      </Popover.Content>
    </Popover>
  );
};
